import { inject, Injectable } from '@angular/core';
import { ELanguage, TNil } from '@app/app.interface';
import { TranslateService } from '@ngx-translate/core';
import { NumberSeparatorUtilitiesService } from '@utilities/number-separator-utilities.service';

@Injectable({
  providedIn: 'root',
})
export class PercentageUtilitiesService {
  private readonly translate = inject(TranslateService);
  private readonly numberSeparatorUtilities = inject(NumberSeparatorUtilitiesService);

  public getPercentage(value: number | TNil, fromFloat = false, decimalPlaces = 2): string {
    if (value === null || value === undefined) {
      return '-';
    }

    let percentage = value;

    if (fromFloat) {
      percentage = value * 100;
    }

    const formattedPercentage = this.numberSeparatorUtilities.formatNumberToLocaleString(
      percentage,
      this.translate.currentLang as ELanguage,
      value === 0 ? 0 : decimalPlaces,
      value === 0 ? 0 : decimalPlaces,
    );

    return formattedPercentage;
  }
}
